import { useLayoutEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

const tabs = [
  { name: "Candidates", path: "candidates" },
  { name: "Companies", path: "companies" },
  { name: "Referral", path: "referral" },
];

const ContactsPageLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (pathname === "/contacts") {
      navigate("candidates");
    }
  }, [pathname]);

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow px-6 py-8">
      {/* Tabs container */}
      <div className="flex items-center overflow-hidden gap-8 border-b pb-2.5">
        {tabs?.map((item) => {
          return (
            <NavLink
              to={item?.path}
              key={item?.name}
              className={({ isActive }) =>
                `flex justify-center items-center h-full cursor-pointer font-medium text-xs border-b-2 ${
                  isActive
                    ? "text-charcoal border-primary"
                    : "text-light-black border-transparent"
                }`
              }
            >
              {item?.name}
            </NavLink>
          );
        })}
      </div>
      <div className="flex flex-1 flex-col overflow-y-hidden no-scrollbar">
        <Outlet />
      </div>
    </div>
  );
};

export default ContactsPageLayout;
